import { createApiRef } from '@backstage/core-plugin-api';
import { AxiosInstance } from 'axios';
import { AxiosInstanceProviderApi } from './axiosInstanceApi';

/* Update the interface as per the data required */
export interface Component {
  id: string | undefined;
  title: string | undefined;
  description: string | undefined;
  url: string | undefined;
  category_id: string | undefined;
  category_name: string | undefined;
}
export interface POCProps {
  name: string | undefined;
  description: string | undefined;
  type: string;
  owneremail: string | undefined;
  repourl: string | undefined;
  scmrepoid: string | undefined;
  scm: string;
  branch: string | undefined;
  links: string[] | undefined;
  status: string;
  tags: string[];
  image: string | undefined;
}

export interface PocHubApi {
  regiterPocComponent: (data: Component) => Promise<any>;
  updateRegisteredComponent: (data: POCProps) => Promise<any>;
  fileUpload: (data: any) => Promise<any>;
  deletePocComponent: (data: any) => Promise<any>;
  readFile: (data: any) => Promise<any>;
  getEntityNameList: () => Promise<any>;
  getHackathonTeams: () => Promise<any>;
}

export const pocHubApiRef = createApiRef<PocHubApi>({
  id: 'cbre.devx.api.pochub',
});

export class PocHubApiImpl implements PocHubApi {
  private readonly axiosInstancePromise: Promise<AxiosInstance>;

  constructor(axiosInstanceProviderApi: AxiosInstanceProviderApi) {
    this.axiosInstancePromise = axiosInstanceProviderApi.getInstance();
  }

  /* Register component */
  async regiterPocComponent(data: Component) {
    const instance = await this.axiosInstancePromise;
    return instance
      .post(`/service/github/webhook/proxy `, data)
      .then(res => res.data);
  }

  async updateRegisteredComponent(data: POCProps) {
    const instance = await this.axiosInstancePromise;
    return instance
      .put(`/service/github/webhook/proxy`, data)
      .then(res => res.data);
  }

  async fileUpload(data: any) {
    const instance = await this.axiosInstancePromise;
    return instance.post(`/file-upload`, data).then(res => res.data);
  }

  async deletePocComponent(data: string) {
    const instance = await this.axiosInstancePromise;
    return instance
      .delete(`/service/github/webhook/proxy/${data}`)
      .then(res => res.data);
  }

  async readFile(data: string) {
    const instance = await this.axiosInstancePromise;
    return instance
      .get(`/file-upload?url=${data}`)
      .then(res => res.data)
  }

  async getEntityNameList() {
    const instance = await this.axiosInstancePromise;
    return instance
      .get('service/github/webhook/proxy/components')
      .then(res => res.data);
  }

  async getHackathonTeams() {
    const instance = await this.axiosInstancePromise;
    return instance
      .get('service/event/3/register/team')
      .then(res => res.data);
  }
}
